<template>
  <div :class="$style.aside">
    <index-search />
  </div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";
import IndexSearch from "~/components/cruise-map/index-search.vue";
export default defineComponent({
	components: {
		IndexSearch
	}
});
</script>
<style lang="scss" module>
.aside {
  position: absolute;
  left: 3rem;
  top: 3rem;
}
</style>